import { getUser, setUser } from './base/auth';
import { http } from './base/http';
import type { User } from './types/user';

export const OrganizationAPIs = {
    async updateOrganization(name: string | null, picture: File | null, onUpdated: () => void): Promise<void> {
        const user = getUser();
        const updates = new FormData();

        if (name) {
            updates.append('name', name);
        }
        if (picture) {
            updates.append('logo', picture);
        }
        http.upload(`/organizations/${user?.organization.id}`, 'PATCH', updates, () => {}, onUpdated);
    },
};
